module.exports = __webpack_public_path__ + "static/media/Bell2.2ae015e8.svg";